import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { AbsolutePositioned } from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { Screen, SplitScreen } from '../../../components/Layout/Screen';
import LineLink from '../../../components/LineLink';
import Title, { Highlight } from '../../../components/Title';
import TextBlock from '../../../components/TextBlock';
import SealAnimation from '../../../components/SealAnimation';

// Assets
import { brandColors, device } from '../../../styles/variables';
import railwayPub from '../../../assets/images/pages/about/kew_outside.jpg';

const StyledScreen = Screen.extend`
  background: url(${railwayPub});
  background-size: cover;
  background-position: 50%;
  height: auto;
  padding: 0 0 50px 0;
  @media ${device.tablet} {
    height: 100%;
    padding: 0;
  }
`;

const ColorBackground = AbsolutePositioned.extend`
  background: ${brandColors.yellow};
  width: 100%;
  height: 100%;
  opacity: 0.8;
`;

const ContentHolder = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
`;

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  display: block;
  width: 100%;
  @media ${device.laptop} {
    display: inline-block;
    vertical-align: top;
    width: 50%;
    height: 100%;
  }
`;

const TitleContainer = styled.div`
  margin: 54px 0 0 0;
  @media ${device.tablet} {
    margin: 165px 0 0 0;
  }
  @media ${device.laptop} {
    margin: 136px 0 0 0;
  }
`;

const TextContainer = styled.div`
  @media ${device.laptop} {
    margin: 388px 0 0 40px;
  }
  @media ${device.laptopL} {
    margin: 388px 0 0 92px;
  }

  .text-block {
    @media ${device.tablet} {
      display: inline-block;
      vertical-align: bottom;
      margin-right: 50px;
    }
  }

  .linelink {
    float: right;
    @media ${device.tablet} {
      float: none;
      display: inline-block;
      vertical-align: bottom;
    }
  }
`;

const SealContainer = styled.div`
  position: absolute;
  left: 40px;
  bottom: 40px;
  @media ${device.tablet} {
    top: 75px;
    left: 61%;
    bottom: unset;
  }
`;

const Testimonials = () => (
  <StyledScreen>
    <ColorBackground />
    <ContentHolder>
      <ContentContainer className="content-container">
        <StyledSplitScreen>
          <TitleContainer>
            <Title color={brandColors.blue}>
              Certified <Highlight>Woman-Owned</Highlight> Business
            </Title>
          </TitleContainer>
        </StyledSplitScreen>
        <StyledSplitScreen>
          <TextContainer>
            <TextBlock className="text-block" width="381.91px">
              <p>
                Did you know that only 18% of small and medium-sized UK businesses are owned and run
                by women (data from 2022)? We are proud to be a certified WEConnect International
                Women-Owned Business.
              </p>
              <p>Are you interested in working with diverse suppliers?</p>
            </TextBlock>
            <LineLink
              className="linelink"
              linkText="contact us"
              linkColor={brandColors.orange}
              route="/contact#contactMain"
              lineColor={brandColors.blue}
              active
            />
          </TextContainer>
        </StyledSplitScreen>
      </ContentContainer>
      <SealContainer>
        <SealAnimation />
      </SealContainer>
    </ContentHolder>
  </StyledScreen>
);

export default connect()(Testimonials);



// WEBPACK FOOTER //
// ./src/pages/About/screens/Testimonials.jsx